import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/administrative-unit-ref-info";

export const pagingAdministrativeUnitRefInfo = (searchObject) => {
  var url = API_PATH + "/paging";
  return axios.post(url, searchObject);
};

export const getAdministrativeUnitRefInfo = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createAdministrativeUnitRefInfo = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editAdministrativeUnitRefInfo = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteAdministrativeUnitRefInfo = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const checkDuplicate = (obj) => {
  let url = API_PATH + "/check-duplicate";
  return axios.post(url, obj);
};